import script from "./setUpPartnership.vue?vue&type=script&setup=true&lang=js"
export * from "./setUpPartnership.vue?vue&type=script&setup=true&lang=js"

import "./setUpPartnership.vue?vue&type=style&index=0&id=78d94602&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d94602"]])

export default __exports__